// extracted by mini-css-extract-plugin
export default {"LoadingHeart":"LoadingHeart-styles__LoadingHeart__oKXzI"};